<template>
    <span class="label"  v-if="label && labeled">{{label}}</span>
    <label class="drop-down" @click="show" @mouseleave="hide">
        <select
            @change="select"
            :class="{ mobile: !native }"
        >
            <option v-if="label" disabled :selected="!modelValue">{{label}}</option>
            <template
                v-for="(item, index) in data"
                :key="index"
            >
                <optgroup v-if="item.options" :label="item.title">
                    <option 
                        v-for="(subitem, subindex) in (!order ? item.options : sort(item.options, order))" 
                        :key="`${index}_${subindex}`"
                        :value="`${index}_${subindex}`"
                    >{{subitem[title] || subitem.title}}</option>
                </optgroup>
                <option v-else :value="index" :selected="modelValue && item.value == modelValue.value">{{item[title] || item.title}}</option>
            </template>
        </select>
        <div class="desktop" v-if="!native">
            <div class="value" v-if="!status" @click="focus">{{selected || label}}</div>
            <input 
                v-model="search"
                @blur="hide"
                @focus="show"
                ref="input"
                type="text"
                :placeholder="selected || label"
                autocomplete="off"
                autocorrect="off" 
                spellcheck="false"
                :name="name"
                :id="name"
            />
            <nav v-if="status && items" @mouseover="show">
                <template
                    v-for="(item, index) in data"
                    :key="`drop-${index}`"
                >
                    <div v-if="item.options">
                        <p v-if="item.title">{{item.title}}</p>
                        <button 
                            v-for="(subitem, subindex) in (!order ? item.options : sort(item.options, order))"
                            :key="`${index}_${subindex}`"
                            class="trigger"
                            @click="change(subitem)"
                        >{{subitem[title] || subitem.title}}</button>
                    </div>
                    <button 
                        v-else
                        class="trigger"
                        @click="change(item)"
                    >{{item[title] || item.title}}</button>
                </template>
            </nav>
        </div>
        <icon :name="img"/>
    </label>
</template>

<script>
import { slugify, sort } from '@/core/utils' 
export default {
    props: {
        placeholder: {
            type: String,
            default: 'Pesquisar'
        },
        title: {
            type: String,
            default: 'title'
        },
        label: String,
        options: Array,
        modelValue: [String, Number, Object, Array, Boolean],
        order: String,
        icon: String,
        searchable: Boolean,
        native: Boolean,
        labeled: {
            type: Boolean,
            default: true
        }
    },
    emits: ['change', 'input', 'update:modelValue'],
    data: () => ({
        search: '',
        status: false,
        hidding: null,
        delay: null,
        filtered: null,

        rodolfo: false
    }),
    methods: {
        sort,
        slugify,
        focus() {
            this.status = true;
        },
        show() {
            this.status = true;
        },
        hide() {
            if(this.rodolfo) this.status = true;
            else {
                clearTimeout(this.hidding);
                this.hidding = setTimeout(() => (this.status = false), 150);
            }
        },
        change(item) {
            this.value = item;
            this.status = false;
        },
        select(item) {
            const val = item.target.value;
            if(!val) this.change();
            else if(!val.includes('_')) this.change(this.items[parseInt(val)]);
            else {
                //TODO ter em conta os q tem options
            }
        },
        filter() {
            if(!this.visible) return;
            let options = [];
            this.options.forEach(item => {
                let status;
                let option = {
                    ...item
                }
                if(!item.options) status = slugify(item[this.title] || item.title).includes(slugify(this.search));
                else {
                    option.options = !item.options ? null : item.options.filter(child => slugify(child[this.title] || child.title).includes(slugify(this.search)))
                    if(option.options.length) status = true;
                }
                status && options.push(option)
            })
            this.filtered = options;
        }
    },
    computed: {
        name() {
            return `${this.$state.id}-${Date.now()}`;
        },
        visible() {
            return this.status && this.search && this.search.length && this.search.length > 2;
        },
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('change', value);
                this.$emit('input', value);
            }
        },
        img() {
            return this.icon || (!this.status ? 'down' : 'up');
        },
        items() {
            return !this.options || !this.options.length ? null : (!this.searchable ? this.options : (!this.visible ? null : this.filtered));
        },
        selected() {
            return (!this.modelValue ? this.label : (this.modelValue.title || this.modelValue.name || this.modelValue)) || ''
        },
        data() {
            return !this.items ? null : (!this.order ? this.items : sort(this.items, this.order));
        }
    },
    watch: {
        search() {
            clearTimeout(this.delay);
            this.delay = setTimeout(this.filter, 250);
        }
    },
    beforeUnmount() {
        clearTimeout(this.hidding);
        clearTimeout(this.delay);
        this.status = false;
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
@import '@/styles/variables.scss';
.label{
	font-size: 0.9rem;
	padding-bottom: 0.25rem;
	display: block;
}
.drop-down {
    width: inherit;
    display: block;
    position: relative;
    height: 36px;
    line-height: 36px;
    margin-bottom: 1.5rem;
    &:focus,
    &:focus-within {
        input {
            @include opacity(0);
            &:-webkit-autofill {
                @include shadow(0 0 0 1000px white inset !important);
            }
            &,
            &:focus,
            &:active {
                @include opacity(1);
            }
        }
    }
    > * {
        width: 260px;
        max-width: 100%;
    }
    select {
        @include appearance();
        &::-ms-expand {
            display: none;
        }
    }
    .value,
    input,
    select {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: inherit;
        line-height: inherit;
        z-index: 1;
        padding: 0 .5rem;
        border: 1px solid var(--base-light-alternative-color);
        font-size: 16px;
        outline: none;
        width: calc(100% - 1rem);
        background: #fff;
    }
    .value {
        background: #fff;
    }
    nav {
        position: absolute;
        top: 36px;
        left: 0;
        right: 0;
        width: 100%;
        background: var(--site-bg-color);
        z-index: 3;
        max-height: 320px;
        overflow-x: hidden;
		overflow-y: auto;
		border:1px solid var(--base-light-alternative-color);
		border-top: none;
        p {
            height: 10px;
			line-height: 40px;
			color: var(--text-color);
			font-size: 0.9rem;
			margin-left: 0.25rem;
			opacity: 0.7;
        }
        button {
            height: 36px;
            line-height: 36px;
            width: 100%;
            text-align: left;
            background: none;
            border: none;
            outline: none;
            cursor: pointer;
			padding-left: .5rem;
			color: var(--text-color);
        }
    }
    ::v-deep(svg) {
        position: absolute;
        top: .35rem;
        pointer-events: none;
        right: .5rem;
        height: 24px;
        width: 24px;
        z-index: 2;
        fill: var(--base-medium-color);
        &.down,
        &.up {
            top: 1rem;
            height: 10px;
            width: 10px;
        }
    }
}
</style>